import styled from 'styled-components'

export const TitleText = styled.span`
  color: #009D00;
`
